"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * datAIndustry
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./api/axes-api"), exports);
__exportStar(require("./api/channel-templates-api"), exports);
__exportStar(require("./api/channels-api"), exports);
__exportStar(require("./api/connectors-api"), exports);
__exportStar(require("./api/exports-api"), exports);
__exportStar(require("./api/machines-api"), exports);
__exportStar(require("./api/notifications-api"), exports);
__exportStar(require("./api/orders-api"), exports);
__exportStar(require("./api/parameters-api"), exports);
__exportStar(require("./api/settings-api"), exports);
__exportStar(require("./api/statistics-api"), exports);
__exportStar(require("./api/time-series-api"), exports);
